<template>
  <div>
    <b-card no-body>
      <b-card-body>
        <b-row class="mb-2">
          <!-- Options de validation -->
          <b-col xl="2" md="4" sm="6">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left">Nbr page</label>
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" :options="pageOptions"/>
            </b-form-group>
          </b-col>

          <b-col xl="2" md="4" sm="6">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left">Année</label>
              <b-form-select id="yearSelect" v-model="currentYear" size="sm" :options="yearOptions"/>

            </b-form-group>
          </b-col>

          <b-col xl="4" sm="12">
            <b-form-group class="mb-0">
              <label class="d-inline-block text-sm-left">Statut</label>
              <v-select class="primary" v-model="selectedStatus" multiple label="label" :options="optionStatus" :reduce="option => option.value" />
            </b-form-group>
          </b-col>

          <b-col xl="4" sm="12">
            <b-form-group label-for="filterInput" class="mb-0">
              <label class="d-inline-block text-sm-left">Filtrer</label>
              <b-input-group size="sm">
                <b-form-input id="filterInput" v-model="filter" type="search" placeholder="Rechercher..." @input="fetchUserEvaluation" />
                <b-input-group-append>
                  <b-button :disabled="!filter" @click="filter = ''; fetchUserEvaluation()">Effacer</b-button>
                </b-input-group-append>
              </b-input-group>
            </b-form-group>
          </b-col>
        </b-row>

        <b-row class="align-items-center mb-2">
          <b-col cols="12" md="4" class="mb-1 mb-md-0">
            <label>Direction</label>
            <v-select
                v-model="selectedDirections"
                :options="directionOptions"
                label="name"
                placeholder="Toutes les directions"
                class="filter-selector"

            />
          </b-col>

          <b-col cols="12" md="4" class="mb-1 mb-md-0">
            <label>Service</label>
            <v-select
                v-model="selectedServices"
                :options="serviceOptions"
                label="name"
                placeholder="Tous les services"
                class="filter-selector"
            />
          </b-col>

          <b-col class="mb-1 mb-md-0">
            <label>Péage</label>
            <v-select
                v-model="selectedToll"
                :options="tollOptions"
                label="name"
                placeholder="Tous les péage"
                class="filter-selector"
            />
          </b-col>

          <b-col cols="auto" class="d-flex justify-content-end align-items-end mt-1">
            <b-button variant="primary" @click="exportUserEvaluations">
              Exporter
            </b-button>
          </b-col>
        </b-row>

        <b-row>
          <b-col cols="12">
            <b-table
                striped
                hover
                responsive
                :items="userEvaluation"
                :fields="tableColumns"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
            >
              <template #cell(user)="data">
                <b-media vertical-align="center">
                  <template #aside>
                    <b-avatar size="40" variant="light-primary" class="badge-minimal" badge-variant="success">
                      {{ getUserInitials(data.item) }}
                    </b-avatar>
                  </template>
                  <span class="font-weight-bold d-block text-nowrap">
                    {{ data.item.fullName}}
                  </span>
                  <small class="text-muted">{{ data.item.mail }}</small>
                </b-media>
              </template>

              <template #cell(fonction)="data">
                <span v-if="data.item.fonction" class="font-weight-bold d-block text-nowrap">
                  {{ data.item.fonction }}
                </span>
                <small v-if="data.item.serviceName" class="text-muted">
                  {{ data.item.serviceName }}
                </small>
              </template>
<!--              <template #cell(services)="data">-->
<!--                <span v-if="data.item.serviceName" class="font-weight-bold d-block text-nowrap">-->
<!--                  {{ data.item.serviceName }}-->
<!--                </span>-->
<!--                <small v-if="data.item.directions" class="text-muted">-->
<!--                  {{ data.item.users.directions.name }}-->
<!--                </small>-->
<!--              </template>-->
              <template #cell(status)="data">
                <b-badge :variant="statusVariants[data.item.status]">
                  {{ statusLabels[data.item.status] }}
                </b-badge>
              </template>
              <template #cell(nextStep)="data">
                <span class="text-primary">{{ nextStepLabels[data.item.status] }}</span>
              </template>
              <template #cell(actions)="data">
                <div class="text-nowrap">

                  <!-- Icône Visualiser -->
                  <feather-icon
                      :id="`evaluation_print-row-${data.item.idPublic}-preview-icon`"
                      icon="EyeIcon"
                      size="16"
                      class="mx-1"
                      @click="formEvaluation(data.item)"
                  />
                  <b-tooltip
                      title="Détail Évaluation"
                      :target="`evaluation_print-row-${data.item.idPublic}-preview-icon`"
                  />


                  <!-- Icône Planifier -->
                  <feather-icon
                      v-if="canChangeDateEvaluation(data.item)"
                      :id="`evaluation-schedule-row-${data.item.userEvaluationIdPublic || data.item.userId}-icon`"
                      icon="CalendarIcon"
                      size="16"
                      class="mx-1"
                      @click="scheduleEvaluation(data.item)"
                  />
                  <b-tooltip
                      title="Définir la date de validation"
                      :target="`evaluation-schedule-row-${data.item.userEvaluationIdPublic || data.item.userId}-icon`"
                  />

                  <feather-icon :id="`${data.item.id}-preview-icon`" icon="EditIcon" size="16"
                                class="mx-1"  @click="handleClick(data.item)"/>
                  <b-tooltip title="Modifier statut" :target="`${data.item.id}-preview-icon`"/>
                </div>
              </template>
            </b-table>
          </b-col>
        </b-row>
      </b-card-body>
      <b-col cols="12">
        <b-pagination
            v-model="currentPage"
            :total-rows="totalRows"
            :per-page="perPage"
            align="center"
            size="sm"
            class="my-1"
        />
        <p>Total: {{ totalRows }} | Par page: {{ perPage }}</p>
      </b-col>
    </b-card>


    <!-- Modale date de l'évaluation -->
    <b-modal id="modal-sm" v-model="isModalActive" modal-class="modal-primary" ok-only ok-title="OK" centered size="sm"
             :title="'Date'" @ok="confirmDateEvaluation">
      <b-row>
        <b-col md="12">
          <b-form-group>
            <h5>Date prévue pour le rendez-vous d'évaluation</h5>
            <!-- <flat-pickr v-model="inlineDate" class="form-control"
                :config="{ enableTime: true, dateFormat: 'd-m-y H:i' }" /> -->
            <flat-pickr v-model="inlineDate" class="form-control" :config="flatPickrConfig" />

          </b-form-group>
        </b-col>
      </b-row>
    </b-modal>

    <b-modal
        id="objective-back-modal"
        title="Retour en arrière"
        ok-title="Confirmer"
        cancel-title="Annuler"
        :ok-disabled="!selectedStatusUpdate"
        v-model="isModalActiveStatus"
        @ok="handleOk"
        centered
    >
      <b-form-group label="Statut" label-for="custom-objective-back">
        <v-select v-model="selectedStatusUpdate"  label="label" :options="availableStatusUpdate"
                  :reduce="option => option.value" />
      </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import {
  BAvatar,
  BBadge,
  BButton,
  BCol,
  BFormGroup,
  BFormInput,
  BFormSelect,
  BInputGroup,
  BInputGroupAppend,
  BModal,
  BPagination,
  BRow,
  BTable
} from 'bootstrap-vue';
import vSelect from 'vue-select';
import {
  getUserEvaluationsReportAll, getUserEvaluationsReportAllToExport,
  updateDateEvaluationMeeting,
  updateDateEvaluationStatus
} from '@/services/UserEvaluationService';
import {allYears} from '@/services/YearsService';
import {getSetting} from '@/services/SettingService';
import {getAllConfigs} from '@/services/EvaluationIntervalConfigsService';
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue';
import {getJsonFromStorage} from '@/util/storageUtils';
import flatPickr from 'vue-flatpickr-component';
import {French} from "flatpickr/dist/l10n/fr";
import moment from "moment/moment";
import {allServicesByDirections} from "@/services/ServicesService";
import {getAllDirectionsByActive} from "@/services/DirectionsService";
import {allPeagesActive} from "@/services/TollService";
import {getUserObjectivesAllToExport} from "@/services/UserObjectiveService";
import * as XLSX from "xlsx-js-style";


export default {
  components: {
    BModal,
    BTable,
    BAvatar,
    BBadge,
    BRow,
    BCol,
    BFormGroup,
    BFormSelect,
    BPagination,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BButton,
    vSelect,
    flatPickr,
  },
  data() {
    return {
      perPage: 10,
      pageOptions: [3, 5, 10, 25, 50, 100, 200],
      totalRows: 0, // Initialisé à 0
      currentPage: 1,
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: ['user', 'fonction', 'services', 'status'],
      userEvaluation: [],
      userEvaluationToExport: [],
      isModalActive:false,
      isModalActiveStatus:false,
      selectedStatusUpdate:null,

      inlineDate: null,
      userEvaluationsData:{},
      currentYear: new Date().getFullYear(), // Valeur par défaut
      evaluationStartDate: null,
      years: [],
      selectedServices:null,
      selectedDirections:null,
      serviceOptions:[],
      directionOptions: [],
      selectedToll: null,
      tollOptions: [],
      selectedStatus: [],
      statusVariants: {
        INPROGRESS: "info",
        TO_EVALUATE: "warning",
        SELF_EVALUATION: "warning",
        EVALUATION: "primary",
        TERMINATED: "warning",
        MEETING: "secondary",
        VALIDATED_BY_HIERARCHY: "success",
        TRANSMIT_HIERARCHY_2: "warning",
        APPROVED: "success",
        VALIDATED_BY_COLLABORATOR: "success",
        REJECTED: "danger",
      },
      nextStepLabels: {
        TO_EVALUATE: "-",
        SELF_EVALUATION: "-",
        EVALUATION: "-",
        TERMINATED: "Attente de rendez-vous !",
        MEETING: "Validation par manager !",
        VALIDATED_BY_HIERARCHY: "Validation par collaborateur !",
        TRANSMIT_HIERARCHY_2: "Validation par manager N+2 !",
        APPROVED: "Validation par collaborateur !",
        VALIDATED_BY_COLLABORATOR: "-",
        REJECTED: "Correction par N+1 !"
      },
      statusLabels: {
        INPROGRESS: "En cours",
        TO_EVALUATE: "À évaluer",
        SELF_EVALUATION: "Auto-Evaluation effectuée",
        EVALUATION: "Évaluation effectuée",
        TERMINATED: "En attente de rendez-vous",
        MEETING: "Rendez-vous pris",
        VALIDATED_BY_HIERARCHY: "Validé par manager",
        TRANSMIT_HIERARCHY_2: "Transmis au manager N+2",
        APPROVED: "Approuvé",
        VALIDATED_BY_COLLABORATOR: "Validé par collaborateur",
        REJECTED: "Rejeté"
      },
      optionStatus: [
        { value: 'INPROGRESS', label: 'En cours' },
        { value: 'SELF_EVALUATION', label: 'Auto Évaluation' },
        { value: 'EVALUATION', label: 'Évaluation effectuée' },
        { value: 'TERMINATED', label: 'En attente de rendez-vous' },
        { value: 'MEETING', label: 'Rendez-vous pris' },
        { value: 'VALIDATED_BY_HIERARCHY', label: 'Validé par manager' },
        { value: 'TRANSMIT_HIERARCHY_2', label: 'Transmis au manager N+2' },

        { value: 'APPROVED', label: 'Approuvé' },
        { value: 'VALIDATED_BY_COLLABORATOR', label: 'Validé par collaborateur' },
        { value: 'REJECTED', label: 'Rejeté' }
      ],
      optionStatusUpdate: [
        // { value: 'SELF_EVALUATION', label: 'Auto Évaluation' },
          // { value: 'EVALUATION', label: 'Évaluation effectuée' },
          { value: 'TERMINATED', label: 'En attente de rendez-vous' },
          { value: 'MEETING', label: 'Rendez-vous pris' },
        { value: 'VALIDATED_BY_HIERARCHY', label: 'Validé par manager' },
        { value: 'TRANSMIT_HIERARCHY_2', label: 'Transmis au manager N+2' },
        { value: 'REJECTED', label: 'Rejeté' },
        { value: 'APPROVED', label: 'Approuvé' },
        { value: 'VALIDATED_BY_COLLABORATOR', label: 'Validé par collaborateur' }

      ],
      userData: null,
      configs: [], // Pour stocker les configurations
      currentEvaluation: null,

    };
  },
  computed: {

    availableStatusUpdate: function () {
      if (!this.currentEvaluation) return []
      const {status, rejetHierachyn, evaluationSignatureIds} = this.currentEvaluation

      const signatures = evaluationSignatureIds || []
      let statuses = [...this.optionStatusUpdate]
      statuses = statuses.filter(s => s.value !== 'REJECTED')

      if (status === 'VALIDATED_BY_COLLABORATOR' && signatures.length ===1) {
        statuses = statuses.filter(s => s.value !== 'TRANSMIT_HIERARCHY_2')
        statuses = statuses.filter(s => s.value !== 'APPROVED')
      }
      let currentIndex = statuses.findIndex(
          s => s.value === status
      )

      return statuses.slice(0, currentIndex)
    },
    yearOptions() {
      return this.years.map(y => ({
        value: y.year,
        text: y.year.toString(),
      }));
    },
    tableColumns() {
      return [
        { key: 'user', label: 'Nom Prénom(s)', sortable: true },
        { key: 'fonction', label: 'Fonction', sortable: true },
        { key: 'status', label: 'Statut', sortable: true },
        { key: 'nextStep', label: 'Prochaine étape', sortable: true },
        { key: 'actions', label: 'Actions' },
      ];
    },
    flatPickrConfig() {

      this.getIntervalDays()

      let today = this.evaluationStartDate
          ? moment(this.evaluationStartDate, "DD-MM-YYYY HH:mm").toDate()
          : new Date();

      let daysToAdd = this.evaluationDeadline;

      if (this.userEvaluationsData.status === "MEETING") {
        daysToAdd += 5;
      }

      let maxDate = new Date(today);
      maxDate.setDate(today.getDate() + daysToAdd);

      const datePropose = this.userEvaluationsData.dateEvaluationPropose
          ? moment(this.userEvaluationsData.dateEvaluationPropose, "DD-MM-YYYY HH:mm").toDate()
          : moment(this.userEvaluationsData.dateEvaluationPrevu, "DD-MM-YYYY HH:mm").toDate();

      const now = new Date();
      const minDaysFromNow = 5;
      maxDate.setDate(today.getDate() + daysToAdd);

      if (
          maxDate <= now ||
          (maxDate - now) / (1000 * 60 * 60 * 24) < minDaysFromNow

      ) {
        today = now;

        maxDate = new Date();

        if(  datePropose > maxDate){
          maxDate.setDate(datePropose.getDate() + minDaysFromNow);

        }else {
          maxDate.setDate(today.getDate() + minDaysFromNow);

        }
      }

      return {
        enableTime: true,
        time_24hr: true,
        enableSeconds: false,
        inline: true,
        altInput: true,
        altFormat: "d-m-Y H:i",
        dateFormat: "d-m-Y H:i",
        minDate: today,
        maxDate,
        locale: French,
        disable: [
          function(date) {
            return date.getDay() === 0 || date.getDay() === 6;
          }
        ]
      };
    }
  },
  methods: {
    handleClick(evaluation) {
      this.currentEvaluation = { ...evaluation }

      this.selectedStatusUpdate = null
      this.isModalActiveStatus = true
    },
    handleOk(){


      const message = `
        <span class="small-swal-message">
          Êtes-vous sûr de vouloir modifier le statut de l'objectif ${this.currentEvaluation.years} de
          <strong>${this.currentEvaluation.fullName}</strong>
          vers : <span class="text-danger font-weight-bolder">${this.statusLabels[this.selectedStatusUpdate]}</span> ?
        </span>
      `;

      this.$swal({
        title: '<span class="small-swal-title">Vous ne pourrez pas revenir en arrière !</span>',
        html: message,
        // text: message,
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Oui, modifier !',
        cancelButtonText: 'Annuler',
        // customClass: {
        //   popup: 'small-swal',
        //   title: 'small-swal-title',
        //   htmlContainer: 'small-swal-text',
        //   icon: 'small-swal-icon',
        //   confirmButton: 'btn btn-primary',
        //   cancelButton: 'btn btn-outline-danger ml-1',
        // },
        customClass: {
          popup: 'small-swal',
          title: 'small-swal-title',
          htmlContainer: 'small-swal-text',
          icon: 'small-swal-icon',
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then(result => {
        if (result.isConfirmed) {
          this.currentEvaluation.status = this.selectedStatusUpdate

          updateDateEvaluationStatus(
              this.currentEvaluation.idPublic,
              this.userData.id,
              this.currentEvaluation
          )
              .then(response => {

                this.userEvaluation.splice(this.userEvaluation.findIndex(obj => obj.idPublic === response.idPublic), 1, response)
                this.$swal({
                  icon: 'success',
                  title: 'Modifié !',
                  text: 'Le statut a été mis à jour.',
                  customClass: {
                    confirmButton: 'btn btn-success',
                  },
                })

              })
              .catch(error => {
                console.error('Error updating user objective:', error)
              })

        }
      })


      // updateDateObjectiveStatus(this.currentObjectif.id,this.userData.id,this.currentObjectif).then(response => {
      //
      // }).catch(error => {
      //   console.error('Error updating user objective:', error)
      // })
      // this.fetchUserObjectives();
    },
    async onDirectionSelected(direction) {

      if (direction && direction.id) {
        this.serviceOptions = await allServicesByDirections(direction.id);
      } else {
        // Si aucune direction sélectionnée → pas de service filtré
        this.serviceOptions = [];
        this.selectedServices = null;
      }
    },
    async onServiceSelected(service) {

      if (service && service.id && service.toll) {
        this.tollOptions = await allPeagesActive(service.toll);
      } else {
        // Si aucune direction sélectionnée → pas de service filtré
        this.tollOptions = [];
        this.selectedToll = null;
      }
    },
    async fetchOnDirection() {
      try {
        this.directionOptions = await getAllDirectionsByActive(true);

      } catch (error) {
        console.error('Error fetching data:', error);
      }
    },
    tooltipTitle(data) {
      return data.dateEvaluationPrevu ? 'Éditer Évaluation' : 'Définir la date de validation';
    },
    formEvaluation(data) {
      // this.$router.push({name: 'all_evaluation_print', params: {id: data.userEvaluationIdPublic, isRapport: 1}});
      this.$router.push({name: 'evaluation_prints', params: {id: data.idPublic, isRapport: 1}});

    },
    showToast(message, color, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: 'Notification',
          icon,
          timeout: 8000,
          text: message,
          variant: color,
        },
      });
    },
    getUserInitials(user) {
      return user.mail ? user.mail.substring(0, 3).toUpperCase() : ''
    },
    async fetchUserEvaluation() {
      try {
       this.userData = getJsonFromStorage('userData');
        if ( !this.currentYear) {
          // this.showToast('Utilisateur non connecté', 'danger', 'AlertTriangleIcon');
          return;
        }

        const response = await getUserEvaluationsReportAll(
            this.currentPage - 1,
            this.perPage,
            this.selectedStatus,
            this.currentYear,
            false,this.filter,
            this.selectedServices?.id,this.selectedDirections?.id,
            this.selectedToll?.id


        );
        if (response && Array.isArray(response.userEvaluation)) {
          this.userEvaluation = response.userEvaluation;

          // map(item => ({
          //   ...item,
          //   user: item,
          // }));

          this.totalRows = response.count || 0;
        } else {
          this.userEvaluation = [];
          this.totalRows = 0;
          this.showToast('Aucune donnée trouvée', 'warning', 'AlertTriangleIcon');
        }
      // }
      } catch (error) {
        console.error('Erreur lors de la récupération des évaluations:', error);
        this.showToast('Erreur lors du chargement des données', 'danger', 'AlertTriangleIcon');
        this.userEvaluation = [];
        this.totalRows = 0;
      }
    },
    async getAllYears() {
      try {
        this.years = await allYears();
      } catch (error) {
        console.error('Erreur lors de la récupération des années:', error);
        this.showToast('Erreur lors du chargement des années', 'danger', 'AlertTriangleIcon');
      }
    },
    async fetchConfigs() {
      try {
        this.configs = await getAllConfigs();
      } catch (error) {
        console.error('Erreur lors de la récupération des configs:', error);
        this.showToast('Erreur lors du chargement des configurations', 'danger', 'AlertTriangleIcon');
      }
    },
    getIntervalDays() {
      const result = this.totalRows * this.perPage;
      const matchingConfig = this.configs.find(config =>
          result >= config.minCollaborators && result <= config.maxCollaborators
      );
      return matchingConfig ? matchingConfig.intervalDays : 14; // Par défaut, 14 jours
    },


    canChangeDateEvaluation(data) {

      return data.status === 'EVALUATION' || data.status === 'TERMINATED' || data.status === 'MEETING';

    },


    getEvaluationDateWithHourSubstracted(date) {
      if(!date) {
        this.showToast('La date de validation est manquante', 'danger', 'danger');
        return;
      }

      const currentDate = moment(date, "DD-MM-YYYY HH:mm", true);

      return  currentDate.subtract(36, 'hours');
    },

    scheduleEvaluation(data) {
      this.userEvaluationsData = { ...data }; // clone to avoid mutation issues

      this.userEvaluationsData.idPublic = data.idPublic;

      // Set the date for the picker
      this.inlineDate = data.dateEvaluationPrevu
          ? data.dateEvaluationPrevu
          : data.dateEvaluationPropose
              ? data.dateEvaluationPropose
              : moment().format('DD-MM-YYYY HH:mm');

      this.isModalActive = true;
    },

    confirmDateEvaluation() {
      if (!this.inlineDate) {
        this.showToast("Veuillez sélectionner une date.", "danger", 'AlertCircleIcon');
        return;
      }

      // Mettre à jour userEvaluationsData
      this.userEvaluationsData.dateEvaluationPrevu = this.inlineDate;


      updateDateEvaluationMeeting(this.userEvaluationsData.idPublic, this.userEvaluationsData, 'RH_PROPOSE')
          .then(result => {
            if (result.status === "MEETING") {

              // this.fetchUserEvaluationData(this.currentYear)

              this.showToast("Date prévue enregistrée avec succès", "success", "BellIcon");
            } else if (result.status === "EVALUATION" || result.status === "TERMINATED") {
              this.showToast("Date proposée enregistrée avec succès", "success", "BellIcon");
            }
            // else {
            //   this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
            // }
          })
          .catch(error => {
            this.showToast("Erreur lors de l'enregistrement de la date", "danger", "BellIcon");
            console.error("Erreur lors de la récupération des données :", error);
          });


    },


    formatDateForExcel(date) {
      if (!date) return '';

      if (Array.isArray(date)) {
        // Format du backend: [year, month, day] ou [year, month, day, hour, minute, second]
        const [year, month, day, hour = 0, minute = 0] = date;
        const formattedDay = String(day).padStart(2, '0');
        const formattedMonth = String(month).padStart(2, '0');
        const formattedYear = String(year); // Année complète (4 chiffres)
        const formattedHour = String(hour).padStart(2, '0');
        const formattedMinute = String(minute).padStart(2, '0');

        if (hour === 0 && minute === 0) {
          return `${formattedDay}-${formattedMonth}-${formattedYear}`;
        }
        return `${formattedDay}-${formattedMonth}-${formattedYear} ${formattedHour}:${formattedMinute}`;
      }

      if (typeof date === 'string') {
        // Gérer les formats: "2026-04-15", "2026-04-15 08:00:00", ou "15-04-26 08:00"
        const parts = date.split(' ');
        const datePart = parts[0];
        const timePart = parts[1];

        const dateSegments = datePart.split('-');
        let day, month, year;

        // Si le premier segment a 4 chiffres, c'est YYYY-MM-DD
        if (dateSegments[0].length === 4) {
          [year, month, day] = dateSegments;
        }
        // Si le dernier segment a 2 chiffres, c'est DD-MM-YY (année courte à corriger)
        else if (dateSegments[2].length === 2) {
          [day, month, year] = dateSegments;
          year = '20' + year; // Convertir 26 en 2026
        }
        // Sinon c'est DD-MM-YYYY
        else {
          [day, month, year] = dateSegments;
        }

        day = String(day).padStart(2, '0');
        month = String(month).padStart(2, '0');

        if (timePart) {
          const [hour, minute] = timePart.split(':');
          return `${day}-${month}-${year} ${hour}:${minute}`;
        }
        return `${day}-${month}-${year}`;
      }

      return '';
    },

    async exportUserEvaluations() {

      if ( this.currentYear) {
        const response = await getUserEvaluationsReportAllToExport(
            null,
            null,
            this.selectedStatus,
            this.currentYear,
            false,this.filter,
            this.selectedServices?.id,this.selectedDirections?.id,
            this.selectedToll?.id
        );

        if (response && Array.isArray(response.userEvaluation)) {
          this.userEvaluationToExport = response.userEvaluation;
          this.totalRowsToExport = response.count || 0;
        }

      }

      if (!this.userEvaluationToExport || this.userEvaluationToExport.length === 0) {
        this.showToast("Aucune évaluation à exporter", "danger");
        return;
      }

      this.showToast("Exportation en cours...", "success");
      const exportData = this.userEvaluationToExport.map(u => ({
        Matricule: u.users.matricule || "",
        Civilité: u.users.civilite || "",
        Nom: u.users.lastName || "",
        Prénom: u.users.firstName || "",
        Téléphone: u.users.telephone || "",
        Email: u.users.mail || "",
        fonctionDate: u.users.fonctionDate || "",
        Fonction: u.users.fonction || "",
        Service: u.users.services?.name || "",
        Direction: u.users.directions?.name || "",
        'Poste Peage': u.toll?.name || "",
        'Manager N1': (u.users.usersHierarchique && u.users.usersHierarchique.length > 0)
            ? u.users.usersHierarchique[0].fullName
            : "-",
        'Manager N2': (u.users.usersHierarchique && u.users.usersHierarchique.length > 1)
            ? u.users.usersHierarchique[1].fullName
            : "-",
        'Date Proposition Objectif': this.formatDateForExcel(u.dateCreate) || "-",
        'Date Entretien Evaluation': this.formatDateForExcel(u.dateEvaluationPrevu) || "-",
        'Date Validation Manager 1': this.formatDateForExcel(u.evaluationSignature?.find(sig => sig.hierarchyn === 1)?.confirmDate) || "-",
        'Validation N2 requise ?': u.evaluationSignature?.find(sig => sig.hierarchyn === 2) ? "Oui" : "Non",
        'Date Validation Manager 2': this.formatDateForExcel(u.evaluationSignature?.find(sig => sig.hierarchyn === 2)?.confirmDate) || "-",
        'Date Acceptation Collaborateur': this.formatDateForExcel(u.dateValid) || "-",
        Commentaire: u.description || "",
        'Commentaire Automatique': u.descriptionAutomatic || "",
      }));


      // 'Note Finale Auto-evaluation': u.reponses?.find(r => r.contentSection?.titre === 'Total final' && r.evaluationSignatureIdPublic === null)?.answerDouble || "",
      // 'Note Finale Evaluation': u.reponses?.find(r => r.contentSection?.titre === 'Total final' && r.evaluationSignatureIdPublic !== null)?.answerDouble || "",
      // 'Appreciation Auto-evaluation': u.reponses?.find(r => r.contentSection?.titre === 'Appréciation' && r.evaluationSignatureIdPublic === null)?.answerString || "",
      // 'Appreciation Evaluation': u.reponses?.find(r => r.contentSection?.titre === 'Appréciation' && r.evaluationSignatureIdPublic !== null)?.answerString || "",


      // Feuille de calcul
      const worksheet = XLSX.utils.json_to_sheet(exportData, {origin: "A2"});

      // Titre centré
      XLSX.utils.sheet_add_aoa(worksheet, [["LISTE DES EVALUATIONS - " + this.currentYear]], {origin: "A1"});

      worksheet["!merges"] = [{
        s: {r: 0, c: 0},
        e: {r: 0, c: Object.keys(exportData[0]).length - 1}
      }];

      worksheet["A1"].s = {
        font: {bold: true, sz: 16},
        alignment: {horizontal: "center", vertical: "center"}
      };

      // Style des entêtes (gris + bordure)
      const headerRow = 1;
      const totalCols = Object.keys(exportData[0]).length;

      for (let c = 0; c < totalCols; c++) {
        const cellRef = XLSX.utils.encode_cell({r: headerRow, c});

        if (worksheet[cellRef]) {
          worksheet[cellRef].s = {
            fill: {fgColor: {rgb: "D9D9D9"}},
            font: {bold: true},
            alignment: {horizontal: "center"},
            border: {
              top: {style: "thin", color: {rgb: "000000"}},
              bottom: {style: "thin", color: {rgb: "000000"}},
              left: {style: "thin", color: {rgb: "000000"}},
              right: {style: "thin", color: {rgb: "000000"}},
            }
          };
        }
      }

      // Trouver les indices des colonnes de dates
      const dateColumns = [
        'Date Proposition Objectif',
        'Date Entretien Objectif',
        'Date Validation Manager 1',
        'Date Validation Manager 2',
        'Date Acceptation Collaborateur'
      ];
      const dateColumnIndices = Object.keys(exportData[0])
          .map((key, index) => dateColumns.includes(key) ? index : -1)
          .filter(index => index !== -1);

      // Bordures pour toutes les cellules et format texte pour les dates
      const range = XLSX.utils.decode_range(worksheet["!ref"]);
      for (let r = 2; r <= range.e.r; r++) {
        for (let c = 0; c < totalCols; c++) {
          const cellRef = XLSX.utils.encode_cell({r, c});
          if (!worksheet[cellRef]) continue;

          // Forcer le type texte pour les colonnes de dates
          if (dateColumnIndices.includes(c)) {
            worksheet[cellRef].t = 's'; // 's' = string/text
            worksheet[cellRef].z = '@'; // Format texte Excel
          }

          worksheet[cellRef].s = {
            ...worksheet[cellRef].s,
            border: {
              top: {style: "thin", color: {rgb: "000000"}},
              bottom: {style: "thin", color: {rgb: "000000"}},
              left: {style: "thin", color: {rgb: "000000"}},
              right: {style: "thin", color: {rgb: "000000"}},
            }
          };
        }
      }

      // Colonnes auto-ajustées
      worksheet["!cols"] = Object.keys(exportData[0]).map(col => ({
        wch: Math.max(col.length + 5, 20)
      }));

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Evaluations " + this.currentYear);

      const today = new Date();
      const year = today.getFullYear();
      const month = String(today.getMonth() + 1).padStart(2, '0');
      const day = String(today.getDate()).padStart(2, '0');
      const datePrefix = `${year}${month}${day}`;

      XLSX.writeFile(workbook, `${datePrefix} - Liste des Evaluations ${this.currentYear}.xlsx`);

      this.showToast("Exportation terminée !", "success");
    }
  },
  watch: {
    selectedStatus(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUserEvaluation();
    },
    currentYear(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUserEvaluation();
    },
    currentPage(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUserEvaluation();
    },
    perPage(newVal, oldVal) {
      if (newVal !== oldVal) this.fetchUserEvaluation();
    },
    selectedDirections(newVal, oldVal){
      this.onDirectionSelected(newVal)
      this.fetchUserEvaluation()
    },
    selectedServices(newVal, oldVal){
      this.onServiceSelected(newVal)
      this.fetchUserEvaluation()
    },
    selectedToll(newVal, oldVal){
      this.fetchUserEvaluation()
    }
  },
  async mounted() {
    await this.getAllYears();
    await this.fetchOnDirection();
    await this.fetchConfigs(); // Charger les configurations
    try {
      const response = await getSetting();
      if (response && response.yearEvaluation) {
        this.currentYear = response?.yearEvaluation?.year;
        this.evaluationStartDate = response?.evaluationStartDate;
      }
    } catch (error) {
      console.error('Erreur lors de la récupération des paramètres:', error);
      this.currentYear = new Date().getFullYear();
      this.showToast('Erreur lors du chargement des paramètres', 'danger', 'AlertTriangleIcon');
    }
    await this.fetchUserEvaluation();
  },
};
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
@import '@core/scss/vue/pages/dashboard-ecommerce.scss';
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
